/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 26.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';
import shallowCompare from 'react-addons-shallow-compare';
import ClassNames from 'classnames';

import {VelocityComponent} from 'velocity-react';

import _get from 'lodash/get';
import _throttle from 'lodash/throttle';

import {positiveOrZero, positiveOrZeroAndLessThan} from '../../utils';

class ViewSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slowMotion: 0.1,
      speed: 1,
      lastClientPositionX: 0,
      lastClientPositionY: 0,
      topPosition: 0,
      leftPosition: 0,
      isDragging: false
    };

    this._bindedHandleMouseMove = _throttle(this._handleMouseMove.bind(this), 30);
    this._bindedHandleMouseUp = this._handleMouseUp.bind(this);
    this._bindedHandleTouchMove = _throttle(this._handleTouchMove.bind(this), 30);
    this._bindedHandleTouchMovePrevented = function (e) {
      e.preventDefault();
      e.stopPropagation();

      this._bindedHandleTouchMove(e);
    }.bind(this);
    this._bindedHandleTouchEnd = this._handleTouchEnd.bind(this);
  }

  componentDidMount() {

    this.setState({
      leftPosition: positiveOrZero(this.props.scrollXTo)
    });
  }

  shouldComponentUpdate(nextProps, nextState) {

    return shallowCompare(this, nextProps, nextState);
  }

  _makeSmooth() {

    for (var i = 0; i < 5; i++) {
      setTimeout(() => {
        this.setState({
          leftPosition: positiveOrZero(this.state.leftPosition + this._direction.h),
          isDragging: false
        });
      }, 40 * (i + 1) + (i + 1) * 10);
    }
  }

  _computeSizes() {
    let containerHeight = 0;
    let containerWidth = 0;
    let realHeight = 0;
    let realWidth = 0;

    if (this.content) {
      realHeight = this.content.offsetHeight;
      realWidth = this.content.offsetWidth;
    }

    if (this.wrapper) {
      containerHeight = this.wrapper.offsetHeight;
      containerWidth = this.wrapper.offsetWidth;
    }

    return {
      realHeight: realHeight,
      containerHeight: containerHeight,
      realWidth: realWidth,
      containerWidth: containerWidth
    };
  }

  _handlerClickCapture(e) {
    if (this.state.isDragging) {
      e.preventDefault();
      e.stopPropagation();

      this.setState({
        isDragging: false
      });
    }

    return false;
  }

  _handleMouseDown(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      lastClientPositionX: e.clientX,
      lastClientPositionY: e.clientY
    });

    ReactDOM.findDOMNode(this).addEventListener('mousemove', this._bindedHandleMouseMove, true);
    window.addEventListener('mouseup', this._bindedHandleMouseUp);

    return false;
  }

  _handleMouseMove(e) {
    if (e.clientX === this.state.lastClientPositionX && e.clientY === this.state.lastClientPositionY) return;

    let clientX = e.clientX;
    let clientY = e.clientY;
    let deltaX = this.state.lastClientPositionX - clientX;

    let newValX = this.state.leftPosition + deltaX * this.state.speed;

    this.setState({
      lastClientPositionX: clientX,
      lastClientPositionY: clientY,
      leftPosition: (newValX > 0 && newValX < this._computeSizes().realWidth - this._computeSizes().containerWidth) ? newValX : this.state.leftPosition + deltaX * this.state.slowMotion,
      isDragging: true
    });

    return false;
  }

  _handleMouseUp(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      leftPosition: positiveOrZeroAndLessThan(this.state.leftPosition, this._computeSizes().realWidth)
    });


    ReactDOM.findDOMNode(this).removeEventListener('mousemove', this._bindedHandleMouseMove, true);
    window.removeEventListener('mouseup', this._bindedHandleMouseUp);

    return false;
  }

  _handleTouchStart(e) {
    let touches = e.touches;

    if (touches && touches.length === 1) {
      let {clientX, clientY} = touches[0];

      ReactDOM.findDOMNode(this).addEventListener('touchmove', this._bindedHandleTouchMovePrevented);
      window.addEventListener('touchend', this._bindedHandleTouchEnd);

      this.setState({
        lastClientPositionX: clientX,
        lastClientPositionY: clientY
      });
    }

    return false;
  }

  _handleTouchMove(e) {
    e.preventDefault();
    e.stopPropagation();

    let touches = e.touches;
    if (touches && touches.length === 1) {
      let {clientX, clientY} = touches[0];

      let deltaX = this.state.lastClientPositionX - clientX;

      let newValX = this.state.leftPosition + deltaX;

      this.setState({
        lastClientPositionX: clientX,
        lastClientPositionY: clientY,
        leftPosition: (newValX > 0) ? newValX : this.state.leftPosition + deltaX * this.state.slowMotion,
        isDragging: true
      });
    }

    return false;
  }

  _handleTouchEnd(e) {
    e.preventDefault();
    e.stopPropagation();

    ReactDOM.findDOMNode(this).removeEventListener('touchmove', this._bindedHandleTouchMovePrevented);
    window.removeEventListener('touchend', this._bindedHandleTouchEnd);

    let touches = e.changedTouches;
    if (touches && touches.length === 1) {
      let {clientX, clientY} = touches[0];

      if (this.state.lastClientPositionX === clientX) {

        e.target && e.target.click && e.target.click();
      }
    }

    this.setState({
      leftPosition: positiveOrZeroAndLessThan(this.state.leftPosition, this._computeSizes().realWidth - this._computeSizes().containerWidth),
      isDragging: false
    });

    return false;
  }

  _moveLeft() {

    this.setState({
      leftPosition: positiveOrZeroAndLessThan(this.state.leftPosition - 60, this._computeSizes().realWidth - this._computeSizes().containerWidth),
      isDragging: false
    });
  }

  _moveRight() {

    this.setState({
      leftPosition: positiveOrZeroAndLessThan(this.state.leftPosition + 60, this._computeSizes().realWidth - this._computeSizes().containerWidth),
      isDragging: false
    });
  }

  render() {

    if (!this.props.children) {

      return null;
    }

    var gridCSS = {
      transform: 'translate3d(' + (-1) * parseInt(this.state.leftPosition, 10) + 'px, ' + (-1) * parseInt(this.state.topPosition, 10) + 'px, 0px)'
    };

    return (<div id="view-slider">
      <div className="block-left-grad block-week-days-grad">
        <div className="pointer left-arrow" style={{position: 'absolute', top: '25px', left: '0'}} onClick={this._moveLeft.bind(this)}>
          <i className="ic ic-chevron-left"></i>
        </div>
      </div>
      <div ref={x => this.wrapper = x}
           className="scroll grab-cursor"
           onClickCapture={this._handlerClickCapture.bind(this)}
           onMouseDown={this._handleMouseDown.bind(this)}
           onTouchStart={this._handleTouchStart.bind(this)}
           style={gridCSS}>
        <div className="placeholder-left"></div>
        <div
          ref={x => this.content = x}
          className={'scroll-container ' + (this.props.contentClasses || '')}
          style={this.props.contentStyle || {}}>
          {this.props.children}
        </div>
        <div className="placeholder-right"></div>
      </div>
      <div className="block-right-grad block-week-days-grad">
        <div className="pointer right-arrow" style={{position: 'absolute', top: '25px', right: '0'}} onClick={this._moveRight.bind(this)}>
          <i className="ic ic-chevron-right"></i>
        </div>
      </div>
    </div>);
  }
}

//TODO: Wheel & Keys event
ViewSlider.propTypes = {
  onMove: PropTypes.func,
  wrapperClasses: PropTypes.string,
  contentClasses: PropTypes.string
};

export default ViewSlider;



// WEBPACK FOOTER //
// ./src/components/ViewSlider/index.js